let fault: Error | undefined;
let workerInitError: Error | undefined;
let isSupported = true;
export function getDataWorkerFault(): Error | undefined {
    return fault;
}

export function getIsDataWorkerFaulted(): boolean {
    return !!fault;
}

export function setIsDataWorkerFaulted(e: Error | undefined): void {
    fault = e;
}

export function setDataWorkerInitError(e: Error | undefined): void {
    workerInitError = e;
}

export function setIsDataWorkerNotSupported(): void {
    isSupported = false;
}

type DataWorkerState = "Healthy" | "Faulted" | "Unsupported" | "InitError";
export function getDataWorkerState(): DataWorkerState {
    if (fault) {
        return "Faulted";
    }
    if (workerInitError) {
        return "InitError";
    }
    if (!isSupported) {
        return "Unsupported";
    }
    
    return "Healthy";
}
